import { render } from "./inboxTable.vue?vue&type=template&id=09ac9aba"
import script from "./inboxTable.vue?vue&type=script&lang=js"
export * from "./inboxTable.vue?vue&type=script&lang=js"

import "./inboxTable.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__